/* The partner shop shown in the home-page demos: printerLocationId 2 on production. */
export const SHOP = { name: "PrintAnywhere Partner", address: "Solapur, Maharashtra", distance: "0.4 km" };
export const ORDER_NO = "2312";
